









import { Component, Vue } from 'vue-property-decorator';
import TitleBar from '@/components/layout/TitleBar.vue';
import {SET_LAYOUT_CONFIG} from "@/store/layout_module";

@Component({
  components: {
    TitleBar
  },
})
export default class Welcome extends Vue {

  get latestGoal() {
    if (this.$store.state.data) {
      if (this.$store.state.data.goals && this.$store.state.data.goals.length) {
        return this.$store.state.data.goals[0].goalKey
      }
      return 'latest';
    }
    return 'latest';
  }

  private mounted() {
    const storage = window.localStorage;
    storage.setItem('SEEN_WELCOME', '1');
  }


}
